<template>
    <div class="layout-with-centered-max-width-child">
      <div>
        <div v-if="loadingStarted">
          <Loading></Loading>
        </div>
        <div v-else-if="loadingSuccessful">
          <div class="study-info-container">
            <div class="heading-container">
              <span class="font-secondary heading">Study Info</span>
            </div>
            <StudyInfo></StudyInfo>
          </div>
        </div>
        <div v-else-if="loadingFailed">
          <div class="centered-row">
            <ErrorPage>
              <div slot="header">ERROR</div>
              <div slot="message">Sorry, there was an error loading the page</div>
            </ErrorPage>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {
    LOAD_PUBLIC_STUDY_INFO,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED
  } from "../../services/constants"
  import ErrorPage from "./ErrorPage"
  import StudyInfo from "./StudyInfo"

    export default {
        name: "StudyInfoContainer",
      components: {StudyInfo, ErrorPage},

      created() {
        this.$store.dispatch(LOAD_PUBLIC_STUDY_INFO, this.$route.params.id)
      },

      computed:{
        loadingStatus(){
          return this.$store.state.dataModule.publicStudyInfo.loadingState
        },
        loadingStarted(){
          return this.loadingStatus === LOADING_STARTED
        },
        loadingSuccessful(){
          return this.loadingStatus === LOADING_COMPLETED_SUCCESS
        },
        loadingFailed(){
          return this.loadingStatus === LOADING_COMPLETED_FAILURE
        },
      }
    }
</script>

<style scoped lang="scss">

  @import "../../scss/main";

  .study-info-container{
    padding: 2em 3em;
  }

  .heading-container{
    padding: 1em 0 1em 0;
  }

  .heading{
    color: $red-2;
    font-size: 20pt;
  }

</style>
